
const prodConfig = {
  environment: 'PROD',
  // API
  api: {
    baseURL: 'https://x0mff6tbw2.execute-api.eu-central-1.amazonaws.com/prod'
  },
  version : "3.8.2-prod"
}

const devConfig = {
  environment: 'DEV',
  // API
  api: {
    baseURL: 'https://cya5yhoali.execute-api.eu-central-1.amazonaws.com/dev'
  },
  version: "3.2-dev"
}

const config = {
  prod: prodConfig,
  dev: devConfig
}
export default config
